import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const CalenderDownIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.293 0.792969C10.6835 0.402445 11.3165 0.402445 11.707 0.792969C12.0976 1.18349 12.0976 1.81651 11.707 2.20703L6.70704 7.20703C6.31652 7.59756 5.6835 7.59756 5.29298 7.20703L0.292978 2.20703L0.224619 2.13086C-0.0957313 1.73809 -0.0731375 1.15909 0.292978 0.792969C0.659094 0.426854 1.2381 0.40426 1.63087 0.72461L1.70704 0.792969L6.00001 5.08594L10.293 0.792969Z"
      fill="#EEF7FF"
    />
  </svg>
);
export default CalenderDownIconDark;
